import { graphql } from "relay-runtime"

export const deLegalGuardianAttestationFragment = graphql`
  fragment deLegalGuardianAttestationFragment on de_AttestationGuardian {
    id
    fileId
    progressNoteId
    durationFrom
    durationTo
    certificate
    firstName
    lastName
    birthDate
    updatedAt
    updatedBy
    createdAt
    createdBy
    signedBy
    signedAt
    concludedAt
    concludedBy
    fileMetadata {
      documentType
      extension
      lengthInKilobytes
    }
  }
`
